




import Vue from "vue";
import processingRequestsConfirmation from "@/components/processing-requests/processing-requests-confirmation.component.vue";
export default Vue.extend({
  components: {
    "processing-requests-confirmation": processingRequestsConfirmation,
  },
});
